import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddNewUser from "../AddNewUser";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";

const aiDishaApi = createInstance("DISHA");

const UserManagement = () => {
  const [user_id, setUser_id] = useState("");
  const [name, setName] = useState("");
  const [users, setUsers] = useState([]);
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [Date_of_birth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [organization, setOrganization] = useState("");
  const [accountsFilter, setAccountsFilter] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userIdToChange, setUserIdToChange] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/get-all-users`);
      const data = response.data;
      console.log("Fetched data from API:", data);
      setData(data["All_users"]);
    } catch (error) {
      console.error("Error fetching user data:", error.message);
      Toast.error("Failed to fetch user data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      console.log("Data:", data);
    }
  }, [data]);

  useEffect(() => {
    if (
      user_id === "Default" &&
      name === "" &&
      gender === "" &&
      email === "" &&
      mobile === "" &&
      organization === "Upl Snipe" &&
      Date_of_birth === "" &&
      address === "" &&
      state === "" &&
      city === "" &&
      role === "" &&
      status === "InActive"
    ) {
      fetchData();
      setPage(0);
      setIsEdit(false);
    }
  }, [
    user_id,
    name,
    gender,
    email,
    mobile,
    organization,
    Date_of_birth,
    address,
    state,
    city,
    role,
    status,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddUserModalOpen = () => {
    setIsEditMode(false);
    setSelectedUserForEdit(null);
    setIsAddUserModalOpen(true);
  };

  const handleAddUserModalClose = (newUser) => {
    setIsAddUserModalOpen(false);
    setIsEditMode(false);
    setSelectedUserForEdit(null);
    if (newUser) {
      setUsers([...users, newUser]);
    }
  };

  const handleEditUserModalOpen = (user) => {
    console.log("Opening edit modal for user:", user);
    setSelectedUserForEdit(user);
    setIsEditMode(true);
    setIsAddUserModalOpen(true);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const handleAccountsFilterChange = (event) => {
    setAccountsFilter(event.target.value);
    setPage(0);
  };

  const filteredData = data.filter((user) => {
    const userName = user.name || "";
    const searchMatch = userName.toLowerCase().includes(searchTerm.toLowerCase());
    let accountsMatch = true;

    if (accountsFilter === "active") {
      accountsMatch = user.status === "Active";
    } else if (accountsFilter === "inactive") {
      accountsMatch = user.status === "InActive";
    }

    console.log(`User ${user.user_id}: searchMatch=${searchMatch}, accountsMatch=${accountsMatch}`);
    return searchMatch && accountsMatch;
  });

  const paginatedFilteredData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const userHeader = [
    "User_id",
    "Name",
    "Email",
    "Mobile",
    "Address",
    "Organization",
    "Gender",
    "State",
    "City",
    "Role",
    "Status",
    "Actions",
  ];

  const handleModalOpen = (userId, currentStatus) => {
    console.log("Checking status:", userId, currentStatus);
    setUserIdToChange(userId);
    setSelectedStatus(currentStatus);
    setActionType(currentStatus === "Active" ? "Deactivate" : "Activate");
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleConfirm = async () => {
    await handleActivateDeactivateUser(userIdToChange, selectedStatus);
    setIsModalOpen(false);
  };

  const handleActivateDeactivateUser = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "InActive" : "Active";
      console.log("Updating status for user:", userId, newStatus);
      const response = await aiDishaApi.patch(`/update-status?user_id=${userId}&status=${newStatus}`);
      if (response.status === 200) {
        Toast.success(`User ${newStatus === "Active" ? "activated" : "deactivated"} successfully`);
        fetchData();
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      Toast.error("Failed to update user status");
    }
  };

  const CssFormControl = styled(FormControl)({
    "& label": {
      color: "#033538",
      "&.Mui-focused": {
        color: "#033538",
      },
    },
    "& .MuiInputBase-root": {
      color: "#033538",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#033538",
        borderRadius: 10,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#033538",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#033538",
      },
    },
  });

  const CssSelect = styled(Select)({
    "& .MuiSvgIcon-root": {
      color: "#033538",
      textAlign: "center",
    },
  });

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "5% 1% 0% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "75%",
              borderRadius: 2,
              backgroundColor: "#033538",
            }}
          >
            <IconButton
              type="button"
              sx={{ p: "8px", color: "white" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color: "white" }}
              placeholder="Search by User Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>

        <Box gridColumn="span 1" sx={{ marginTop: "auto", textAlign: "left" }}>
          <Typography
            display="block"
            gutterBottom
            sx={{ color: "#033538", fontFamily: "poppins" }}
          >
            Filter by:
          </Typography>
        </Box>

        <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left" }}>
          <CssFormControl sx={{ width: "95%" }}>
            <InputLabel>Accounts</InputLabel>
              <CssSelect
                label="Accounts"
                id="accounts-filter"
                size="small"
                value={accountsFilter}
                onChange={handleAccountsFilterChange}
                sx={{ width: "100%", textAlign: "center" }}
              >
                <MenuItem value="" sx={{ color: "#033538" }}>
                  All Accounts
                </MenuItem>
                <MenuItem value="active" sx={{ color: "#033538" }}>
                  Active Accounts
                </MenuItem>
                <MenuItem value="inactive" sx={{ color: "#033538" }}>
                  Inactive Accounts
                </MenuItem>
              </CssSelect>
            </CssFormControl>
          </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", marginLeft: "30%" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#033538",
              marginRight: "10px",
              color: "white",
              fontFamily: "poppins",
            }}
            onClick={handleAddUserModalOpen}
          >
            Add New User
          </Button>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
                marginLeft: "-55px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  <TableRow>
                    {userHeader.map((header, index) => (
                      <TableCell
                        key={index}
                        sx={{ color: "white", borderBottom: 0 }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: "#033538" }}>
                  {Array.isArray(filteredData) && filteredData.length > 0 ? (
                    paginatedFilteredData.map((user, index) => (
                      <TableRow key={index}>
                        {userHeader.slice(0, -1).map((header, headerIndex) => (
                          <TableCell
                            key={headerIndex}
                            sx={{ color: "white", border: "1px solid #ccc" }}
                          >
                            {header === "Date_of_birth" &&
                            user[header.toLowerCase().replace(" ", "_")]
                              ? new Date(
                                  user[header.toLowerCase().replace(" ", "_")]
                                ).toLocaleDateString()
                              : user[header.toLowerCase().replace(" ", "_")]}
                          </TableCell>
                        ))}
                        <TableCell
                          sx={{
                            color: "white",
                            border: "1px solid #ccc",
                            minWidth: "200px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "black",
                                color: "#ffffff",
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "70px",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  backgroundColor: "#1976d2",
                                },
                              }}
                              onClick={() => handleEditUserModalOpen(user)}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  user.status === "Active" ? "#f44336" : "#4caf50",
                                color: "#ffffff",
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  backgroundColor:
                                    user.status === "Active" ? "#d32f2f" : "#388e3c",
                                },
                              }}
                              onClick={() => handleModalOpen(user.user_id, user.status)}
                            >
                              {user.status === "Active" ? "Deactivate" : "Activate"}
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={userHeader.length}
                        sx={{ textAlign: "center", color: "white" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredData.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              sx={{
                backgroundColor: "#006A71",
                color: "white",
                marginLeft: "-55px",
                width: "100%",
                borderRadius: "0 0 10px 10px",
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <AddNewUser
        isOpen={isAddUserModalOpen}
        onClose={handleAddUserModalClose}
        fetchUserData={fetchData}
        editUser={selectedUserForEdit}
        isEditMode={isEditMode}
      />

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="User Status"
        action={handleConfirm}
        actionType={actionType}
      >
        <Typography>
          Are you sure you want to {actionType.toLowerCase()} this user?
        </Typography>
      </Modal>
    </div>
  );
};

export default UserManagement;